module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_02_2016a0e2c6a3190a8dd12fdd7a19bfd1.jpg";